import { render, staticRenderFns } from "./EditServiceBusiness.vue?vue&type=template&id=4dca9c30&scoped=true"
import script from "./EditServiceBusiness.vue?vue&type=script&lang=js"
export * from "./EditServiceBusiness.vue?vue&type=script&lang=js"
import style0 from "./EditServiceBusiness.vue?vue&type=style&index=0&id=4dca9c30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dca9c30",
  null
  
)

export default component.exports